var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowDown = function SvgArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M12.03 22a2 2 0 0 0 1.5-.679l8.199-9.326a1.202 1.202 0 0 0-.985-1.96 1.2 1.2 0 0 0-.817.375l-6.332 7.205a.208.208 0 0 1-.365-.137V3.2A1.2 1.2 0 0 0 12.03 2a1.2 1.2 0 0 0-1.2 1.201v14.274a.21.21 0 0 1-.364.138l-6.333-7.205a1.2 1.2 0 1 0-1.8 1.585l8.198 9.327a2 2 0 0 0 1.5.68"
  })));
};
export default SvgArrowDown;